<template>
  <AjaxTable
      :fields="fields"
      :data="roles"
      :fetch="fetchRoles"
  >
    <template #is_highlighted="{item}">
      <td>
        <CBadge :color="item.is_highlighted ? 'success' : 'secondary'">
          {{ item.is_highlighted ? $pgettext('roles.list', 'Yes') : $pgettext('roles.list', 'No') }}
        </CBadge>
      </td>
    </template>
    <template #actions="{item}">
      <td>
        <CButton variant="outline" color="primary" class="mr-2"
                 v-if="hasPerm('contract_manager.role.update')"
                 @click="onEdit(item.id)"
                 v-translate translate-context="list.actions"
        >
          Edit
        </CButton>
        <CButton @click="onDelete(item.id)" variant="outline" color="danger"
                 v-if="hasPerm('contract_manager.role.delete')"
                 v-translate translate-context="list.actions"
        >
          Delete
        </CButton>
      </td>
    </template>
  </AjaxTable>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AjaxTable from "@/domain/core/components/AjaxTable.vue";

export default {
  name: "Roles",
  components: {AjaxTable},
  data() {
    return {
      fields: [
        {key: 'name', label: this.$pgettext('roles.list', 'Name')},
        {key: 'public_name', label: this.$pgettext('roles.list', 'Public Name')},
        {key: 'is_highlighted', label: this.$pgettext('roles.list', 'Highlighted'), _style: 'width:120px;'},
        {key: 'actions', label: this.$pgettext('roles.list', 'Actions'), sorter: false, filter: false}
      ],
    }
  },
  computed: {
    ...mapGetters('contractManager', [
      'roles'
    ]),
  },
  emits: ['edit'],
  methods: {
    ...mapActions('contractManager', [
      'deleteRole',
      'fetchRoles'
    ]),
    async onDelete(id) {
      await this.deleteRole(id)
    },
    async onEdit(roleId) {
      // Trova l'oggetto role completo dal roleId
      const role = this.roles.results?.find(r => r.id === roleId) || {id: roleId}
      this.$emit('edit', role)
    }
  }
}
</script>